import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { getUnitList } from "../../../services/Inventory/inventory";

function ucfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const Unit = ({
  control,
  name,
  onSelectChange,
  placeholder = "Select",
  disabled,
  dropView,
  onCreate,
  showCreateOption = false,
  refreshKey,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [fetchResponse, setFetchResponse] = useState([]);

  const loadOptions = async () => {
    try {
      const data = await getUnitList();
      const response = data?.data?.map(dta => ({
        label: dta?.unit_code ? ucfirst(dta.unit_code) : "",
        value: dta.id,
        ...dta,
      })) || [];
      
      const options = [...response];
      
      if (showCreateOption && onCreate) {
        options.unshift({
          label: "Create",
          value: "create",
          isCreateButton: true,
        });
      }

      setFetchResponse(options);
    } catch (error) {
      console.error("Error fetching unit list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadOptions();
  }, [refreshKey]);

  return (
    <div>
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field: { onChange, ref, value } }) => (
          <Select
            options={fetchResponse}
            // placeholder={placeholder}
            placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
            isLoading={isLoading}
            inputRef={ref}
            onChange={(selected) => {
              if (selected?.isCreateButton) {
                onCreate(); // This will trigger the parent's onCreate handler
              } else {
                onChange(selected);
                if (onSelectChange) onSelectChange(selected);
              }
            }}
            isDisabled={disabled}
            value={value || null}
            classNamePrefix="react-select"
            className="elevate-dropdown"
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            menuPlacement={dropView ? "top" : "bottom"}
          />
        )}
      />
    </div>
  );
};

export default Unit;